//File imports
import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import { API_LOGOUT_URL } from './loginConstants';
import LoginResultsPojo from './LoginResultPojo';

export class LoginService {
    private httpService = new HttpService();
    private logger = new Logger();

    async get(): Promise<LoginResultsPojo> {
        try {
            const httpResult = await this.httpService.get(API_LOGOUT_URL, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
